module.exports = __webpack_public_path__ + "static/media/story-twitter.85aeae51.png";